import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Paper, Select, MenuItem, Pagination, Typography, FormControl, SelectChangeEvent } from '@mui/material';

import { useFoldersTableOrderAndPaginationState } from '@/features/folders/FoldersTable/hooks';

type TablePaginationProps = {
  handleChangePage: (event: React.ChangeEvent<unknown>, page: number) => void;
  handleChangePageSize: (event: SelectChangeEvent<number>) => void;
};

const pageSizes = JSON.parse(process.env.REACT_APP_PAGINATION_ROWS_PER_PAGE) as string[];

export const TablePagination: React.FunctionComponent<TablePaginationProps> = ({
  handleChangePageSize,
  handleChangePage,
}) => {
  const { t } = useTranslation('folders');

  const {
    total,
    pagination: { page: selectedPage, pageSize: selectedPageSize },
  } = useFoldersTableOrderAndPaginationState();

  return (
    <Paper sx={{ padding: 2, display: 'flex', justifyContent: 'space-between' }}>
      <Box component='span' display='flex' justifyContent='space-between' alignItems='center' flexWrap='wrap'>
        <FormControl sx={{ marginBottom: 0, paddingRight: 2 }}>
          <Select
            value={selectedPageSize}
            sx={{ minWidth: 100 }}
            onChange={handleChangePageSize}
            labelId='page-size-select'
            id='page-size-select'
          >
            {pageSizes.map((pageSize) => (
              <MenuItem key={pageSize} value={pageSize}>
                {pageSize}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Typography color='grey.500' sx={{ minWidth: '250px' }}>
          {t('folders.pagination.rowsPerPage')}
          <Box component='span' padding={2}>
            |
          </Box>
          {total} {t('folders.pagination.result')}
        </Typography>
      </Box>
      <Pagination
        color='primary'
        shape='rounded'
        siblingCount={1}
        boundaryCount={1}
        page={selectedPage}
        count={Math.ceil(total / selectedPageSize)}
        onChange={handleChangePage}
      />
    </Paper>
  );
};
